import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 14rem;

  border-radius: 8px;
  box-shadow: 3px 4px 15px 4px rgba(0, 0, 0, 0.12);

  cursor: pointer;

  > img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    border-radius: 8px;
  }
`;
